import { isOfType } from '../helpers'

const CartographyEntityTypeTuple = [
  'MarkersFolder',
  'Marker',
  'Interpretation',
  'HorizonsFolder',
  'Interpretation2D',
  'Interpretation3D',
  'Survey3D',
  'FaultsFolder',
  'PolygonsFolder',
  'MapsFolder',
  'Map',
  'SurveyFolder',
  'Polygon',
  'Fault',
  'Horizon',
  'Points',
] as const

export const isDroppableInCartography = isOfType(CartographyEntityTypeTuple)
